













import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue";
import NavBar from "@/components/common/NavBar.vue";
import NavMenu from "@/components/common/NavMenu.vue";

@Component({
    components: {
        NavBar,
        NavMenu
    }
})
export default class App extends Vue {
    public menu: { display?: boolean } = { display: false };

    public updateMenu(menu: { display?: boolean }) {
        this.menu = Object.assign({}, menu);
    }
}
